let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dT5iy")).then(() => parcelRequire('9paZH'));